import lodashIsElement from 'lodash/isElement';
import memoizeOne from 'memoize-one';

const isElement = (node: Node | null | undefined): node is HTMLElement =>
  lodashIsElement(node);

const adjustDirectionOfElement = (elem: HTMLElement): void => {
  if (elem?.hasAttribute('dir') || !elem?.textContent) {
    return;
  }

  elem.setAttribute('dir', 'auto');
  const dir = window.getComputedStyle(elem).direction;
  elem.setAttribute('dir', dir);
};

const isBlockLevel = (element: Element, windowObj: Window = window) =>
  windowObj.getComputedStyle(element).display === 'block';

const getDirectionFormattedHtml = memoizeOne(
  (html: string, isRootElement = true): string => {
    if (!document.body) return html;

    const elem = document.createElement('div');
    elem.style.display = 'none';
    // TODO: [TEAMS-12074] Investigate improper use of innerHTML
    elem.innerHTML = html;
    document.body.appendChild(elem); // we need this in order to get the computed property

    elem.childNodes.forEach((child) => {
      if (
        child.nodeType !== Node.ELEMENT_NODE &&
        child.nodeType !== Node.TEXT_NODE
      ) {
        return;
      }

      if (isElement(child) && isBlockLevel(child)) {
        // TODO: [TEAMS-12074] Investigate improper use of innerHTML
        child.innerHTML = getDirectionFormattedHtml(child.innerHTML, false);
        adjustDirectionOfElement(child);
      } else if (isRootElement) {
        const div = document.createElement('div');
        div.appendChild(child.cloneNode(true));
        child.replaceWith(div);
        adjustDirectionOfElement(div);
      }
    });

    document.body.removeChild(elem);
    return elem.innerHTML;
  },
);

const makeSpaceAroundLineNonBreaking = (line: string): string => {
  const arr = line.split('');
  const space = ' ';
  const nonBreakingSpace = '&nbsp;';

  let i = 0;
  let j = arr.length - 1;

  while (arr[i + 1] === space) {
    arr[++i] = nonBreakingSpace;
    i++;
  }

  while (arr[j - 1] === space) {
    arr[--j] = nonBreakingSpace;
    j--;
  }

  return arr.join('');
};

const convertPlainToHtml = (text = ''): string => {
  return text
    .split(/\r\n|\r|\n/g)
    .map((line) => {
      if (!line) {
        return `<br />`;
      }

      return `<div>${makeSpaceAroundLineNonBreaking(line)}</div>`;
    })
    .join('');
};

export { getDirectionFormattedHtml, convertPlainToHtml };
